import React from 'react'

import { FaFire, FaMicrophone, FaPlay } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { EditorialBanner } from '../../../_components'
import {
  BannerDecoration,
  CollagePhoto,
  CollageTape,
  PracticeCollage,
} from '../styles'

const PracticeBanner = () => {
  const navigate = useNavigate()

  return (
    <EditorialBanner
      eyebrow="Tu práctica de hoy"
      eyebrowIcon={<FaFire aria-hidden="true" />}
      title="Calienta tu voz y empieza el día cantando"
      description="Una rutina guiada de 12 minutos para activar respiración, resonancia y articulación."
      actionLabel="Empezar ahora"
      actionIcon={<FaPlay aria-hidden="true" />}
      onAction={() => navigate('/rutina')}
      tone="student"
      visual={
        <PracticeCollage aria-hidden="true">
          <BannerDecoration $position="one" />
          <BannerDecoration $position="two" />
          <BannerDecoration $position="three" />
          <CollagePhoto $position="back">
            <img src="/assets/annabel.png" alt="" />
          </CollagePhoto>
          <CollagePhoto $position="front">
            <img src="/assets/miguel-bautista-img-book.png" alt="" />
          </CollagePhoto>
          <CollageTape />
          <span className="collage-icon">
            <FaMicrophone />
          </span>
        </PracticeCollage>
      }
    />
  )
}

export default PracticeBanner
